// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PVOp","right":"styles_right__2OpSM"};